import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import '../../styles/index.scss';

const SellPillBarLayout = ({leftSectionBar, rightSectionBar, className, orientation}) => {
  return (
    <section className={cs('PillBar', 'PillBar__Container', className)}>
      <div className={cs('pill-bar-left-side', orientation === 'left' ? '' : 'hidden')}>{leftSectionBar}</div>
      <div className={cs('pill-bar-right-side-container', orientation === 'right' ? '' : 'hidden')}>
        <div className="pill-bar-right-side">{rightSectionBar}</div>
      </div>
    </section>
  );
};

SellPillBarLayout.propTypes = {
  leftSectionBar: PropTypes.array,
  rightSectionBar: PropTypes.array,
  className: PropTypes.string,
  orientation: PropTypes.string,
};

export default SellPillBarLayout;
